var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-fab-transition',[(_vm.showScrollButton)?_c('v-btn',{staticClass:"scrollUpBtn",attrs:{"fab":"","color":"primary"},on:{"click":_vm.gotToTop}},[_c('v-icon',[_vm._v("mdi-chevron-double-up")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }